var _a, _UpgradeTiered_id;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { makeStore } from '../customStore';
import { resource } from './resources';
import { get } from 'svelte/store';
class UpgradeTiered {
    constructor(resource, cost, costMultiplier, effectMultiplierInTier, upgradesToNextTier, totalEffectMultiplier = 1, tierUpMultipler = 5, tier = 1, maxTier = 5, bought = 0) {
        var _b, _c, _d;
        this.resource = resource;
        this.cost = cost;
        this.costMultiplier = costMultiplier;
        this.effectMultiplierInTier = effectMultiplierInTier;
        this.upgradesToNextTier = upgradesToNextTier;
        this.totalEffectMultiplier = totalEffectMultiplier;
        this.tierUpMultipler = tierUpMultipler;
        this.tier = tier;
        this.maxTier = maxTier;
        this.bought = bought;
        this.id = (__classPrivateFieldSet(_b = UpgradeTiered, _a, (_d = __classPrivateFieldGet(_b, _a, "f", _UpgradeTiered_id), _c = _d++, _d), "f", _UpgradeTiered_id), _c);
    }
}
_a = UpgradeTiered;
_UpgradeTiered_id = { value: 0 };
export const upgradesTieredInitial = {};
export const upgradesTiered = makeUpgradesStore(upgradesTieredInitial);
function makeUpgradesStore(initialState) {
    const store = makeStore(initialState);
    const buy = (name) => {
        store.update($store => {
            const upgrade = $store[name];
            let checkoutCost = 0;
            const res = get(resource)[upgrade.resource];
            if (res < upgrade.cost)
                return $store;
            checkoutCost = upgrade.cost;
            upgrade.cost *= upgrade.costMultiplier;
            upgrade.bought++;
            upgrade.totalEffectMultiplier *= upgrade.effectMultiplierInTier[upgrade.tier - 1];
            const toNextTier = upgrade.upgradesToNextTier[upgrade.tier - 1];
            if (toNextTier !== undefined && upgrade.bought >= toNextTier) {
                upgrade.tier++;
                upgrade.bought = 0;
                // divide thru costMultiplier so it cancels out
                upgrade.cost *= upgrade.tierUpMultipler / upgrade.costMultiplier;
                upgrade.totalEffectMultiplier *= 10;
            }
            resource.update($resource => {
                $resource[upgrade.resource] -= checkoutCost;
                return $resource;
            });
            return $store;
        });
    };
    return Object.assign(Object.assign({}, store), { buy });
}
